<template>
    <layout v-if="hasAccess">
        <template slot="content">
            <ini-content-title :title="title" icon="ticket"></ini-content-title>
            <ini-filter :title="filterTitle" :items="filterItems" @change="updateList($event)"></ini-filter>
            <ini-list :entries="entries" :title="title" @item-clicked="showDetail"></ini-list>
        </template>
    </layout>
</template>

<script>
    import Index from '@/pages/Index'
    import IniList from '@/components/HelpDesk/List/List'
    import IniFilter from '@/components/HelpDesk/List/Filter'
    import IniContentTitle from '@/components/ContentTitle'

    export default {
        extends: Index,

        data() {
            return {
                filterTitle: this.$t('LBL_FILTER_BY'),
                filterItems: [],
                hasAccess: false
            }
        },

        components: {
            IniList,
            IniFilter,
            IniContentTitle
        },

        beforeMount() {
            this.hasAccess = this.$store.getters.getStructure.access && this.$store.getters.getStructure.access.client_portal
        },

        mounted() {
            // Inits filters
            let fields = this.$store.getters.getStructure.modules['HelpDesk'].blocks['LBL_TICKET_INFORMATION'].fields
            let ticketStatusField = fields.ticketstatus
            let ticketPrioritiesField = fields.ticketpriorities
            let contactList = this.$store.getters.getStructure.contacts_list

            if(ticketStatusField){
                this.filterItems.push({name: ticketStatusField.name, title: ticketStatusField.label,
                    column: 'status', options: this.transformPickListValues(ticketStatusField.picklistvalues)})
            }
            if(ticketPrioritiesField){
                this.filterItems.push({name: ticketPrioritiesField.name, title: ticketPrioritiesField.label,
                    column: 'priority', options: this.transformPickListValues(ticketPrioritiesField.picklistvalues)})
            }
            if(contactList.length > 1){
                this.filterItems.push({name: 'reporter', title: this.$t('LBL_REPORTER'), column: 'contact_id',
                    options: this.transformContactsListValues(contactList)})
            }
        },

        methods: {
            transformPickListValues(values) {
                let options = []

                for(let value in values){
                    options.push({id: value, label: values[value]})
                }

                return options
            },

            transformContactsListValues(contactsList){
				let options = []

				contactsList.forEach((contact) => {
					if (contact.record_id == null) {
						options.push({value: 'null', label: this.$t('LBL_UNKNOWN')})
					} else {
						options.push(({
							value: contact.record_id,
							label: contact.firstname.displayValue + ' ' + contact.lastname.displayValue
						}))
					}
				})

				return options
			},

            updateList(filters) {
                this.$store.dispatch('fetchList', {module: this.module, filters: filters})
            },

            showDetail(entry) {
                this.$router.push({ name: 'Detail', params: {view: 'DetailView', module: this.module, record: entry.record_id}})
            }
        }

    }
</script>
<style lang="scss">@import "@/assets/scss/pages/HelpDesk/_index.scss";</style>